module.exports = __webpack_public_path__ + "static/img/pigletTop.7eb7269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pigletTop.png
// module id = 2RQ8
// module chunks = 2